<template>
<div class="card">
    <div class="card-header">
        <p class="card-header-title">Add a Badge</p>
    </div>
    <div class="card-content">

        <div class="columns">
            <div class="column is-full">
                <input class="input is-success" type="text" placeholder="Title" v-model="input.title">
            </div>
        </div>

        <div class="columns">
            <div class="column is-half">
                <div class="myLabel">Image:</div>
                <v-select :options="options" label="title" class="badgeDropdown" key="_id" v-model="input.logoID">
                    <template slot="option" slot-scope="option">
                        <img :src="option.thumb" class="badgeImage" />
                        <div class="badgeTitle">{{ option.title }}</div>
                    </template>
                </v-select>
            </div>
            <div class="column is-half">                            
                <div class="myLabel">Colour:</div> 
                <verte picker="square" model="hex" v-model="input.logoColour" style="margin-top: 3px; z-index: 200 !important;"> 
                </verte>
            </div>
        </div>

        <div class="columns">
            <div class="column is-2">Trigger:</div>
            <div class="column is-10"><div class="myInput">
                    <b-radio v-model="input.triggerType" native-value="1" value="1" disabled=true>
                        Predefined Award
                    </b-radio>
                    <b-radio v-model="input.triggerType" native-value="2" value="2">
                        Custom Award
                    </b-radio>
                </div>
            </div>
        </div>

        <div class="columns"  v-show="input.triggerType === '1'">
            <div class="column is-2">Predefined Award:</div>
            <div class="column is-10"><b-select id="predefinedTrigger" name="predefinedTrigger" v-model="input.predefinedTrigger">
                <option selected value="1">Top in class (month)</option>
                <option value="2">Top in school (month)</option>
            </b-select></div>
        </div>

        <div class="field" id="customTriggerBox" v-show="input.triggerType === '2'">
            <multiselect v-model="input.customTrigger" :options="customTriggerOptions" :close-on-select="true" :multiple="true" :hide-selected="true" label="name" track-by="name" placeholder="Select behaviors to award this badge to"></multiselect>
            <i>For the time being, please select ONLY ONE behavior, else the badge won't work.</i>
        </div>

        <div class="columns" v-show="input.triggerType === '2'">
            <div class="column is-2">Threshold:</div>
            <div class="column is-10"><input class="input" type="number" placeholder="The minimum number of total points to achive to receive this badge" v-model="input.threshold"></div>
        </div>        

        <div class="columns">
            <div class="column is-2">Status:</div>
            <div class="column is-10">
                <b-radio v-model="input.status" native-value="1">
                    Active
                </b-radio>
                <b-radio v-model="input.status" native-value="0">
                    Inactive
                </b-radio>
            </div>
        </div>

        <div class="columns">
            <div class="column is-full"><button class='button is-primary  is-fullwidth' v-on:click="sendForm()" >Create</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import Verte from 'verte';
import 'verte/dist/verte.css';
import Multiselect from 'vue-multiselect'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {    
            options: [],
            customTriggerOptions: [{
                _id: '',
                name: '',
            }],
            input: {
                title: '',
                logoID: '',
                logoColour: '#0C4BF7',
                triggerType: '2',
                predefinedTrigger: '1',
                customTrigger: [],
                threshold: '',
                description: '',
                status: 1,
            },
            schoolPlan: 1
        };
    },
    created() {
        var getSchoolPlan = localStorage.getItem('plan')
        console.log("getSchoolPlan")
        console.log(getSchoolPlan)
        if (getSchoolPlan){
            this.schoolPlan = getSchoolPlan
        }
        console.log("this.schoolPlan")
        console.log(this.schoolPlan)
        this.getBadgesImages();
        this.getCustomTriggerOptions();
    },
    components:{
        Verte,
        Multiselect
    },
    methods: {
        getBadgesImages(){
            console.log("entering getBadgesImages")
            let self = this;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/badges/logo/list', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID')
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    self.options = response.data
                    console.log("131 self.options")
                    console.log(self.options)
                    for (var i = 0; i < self.options.length; i++){
                        self.options[i].thumb = "http://admin.studentqr.com/badges/" + self.options[i].thumb
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        getCustomTriggerOptions(){
            console.log("entering getCustomTriggerOptions")
            let self = this;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/auth/positive/list', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID')
                    }
                })
                .then(response => {
                    self.customTriggerOptions = response.data
                })
                .catch(e => {
                    console.log(e)
                })
        },
        sendForm() {
            if (this.schoolPlan == 3){
                Toast.open({
                    message: "Sorry, your account plan doesn't allow you to create any badges. Please upgrade your account to start creating badges.",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (this.input.title.length < 1){
                Toast.open({
                    message: "Please enter the title for the badge",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            
            try {                
                if (this.input.logoID._id.length < 5){
                    Toast.open({
                        message: "Please select the image for the badge",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }catch (err){
                console.log(err)
                Toast.open({
                    message: "Please select the image for the badge",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }

            if (this.input.triggerType == 1){
                if (this.input.predefinedTrigger == ''){
                    Toast.open({
                        message: "Please select the predefined award from the drop down list list",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }else if (this.input.triggerType == 2){
                if (this.input.customTrigger.length < 1){
                    Toast.open({
                        message: "Please select at least one behavior from the drop down list",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
                if (this.input.customTrigger.length > 1){
                    Toast.open({
                        message: "Sorry, currently you can only select one behavior for a badge.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
                if (this.input.threshold < 1){
                    Toast.open({
                        message: "Please enter the threshold (the minimum number of points to achieve to receive the badge)",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    return false;
                }
            }else{
                //shouldn't reach here actually
                Toast.open({
                    message: "Please select the trigger type",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }

            //if everything ok, get here
            const title = this.input.title;
            this.$emit('add-content', {
                title,
                done: false,
            });

            this.input.email = localStorage.getItem('email')
            this.input.sessionID = localStorage.getItem('sessionID')

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/badges/add', this.input)

                .then(response => {
                    if (response.data.success == false) {
                        Toast.open({
                            message: response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            message: "Badge added successfully",
                            type: 'is-success',
                            duration: 3000
                        })
                        console.log("OK 157")
                        this.$parent.getBadges()
                    }

                    this.input.title = '';
                    this.input.customTrigger = [];
                    this.input.threshold = '';
                })
                .catch(e => {
                    console.log("172?")
                    console.log(e)
                    if (e.response.status === 401) {
                        console.log("salah login")           
                        alert("Unauthorized access. Please re-login.")
                    } else {
                        
                        Toast.open({
                            message: "Sorry, an error has occurred. Please try again later.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                    }
                })
         
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.myLabel{
    float: left;
    width: 15%;
    padding: 5px;
}
.badgeDropdown{
    width: 300px;
}
.badgeImage{
    width: 50px;
}
.badgeTitle{
    padding-top: 30px !important;
    float: right;
}
.myInput{
    float: left;
    width: 80%;
    padding: 5px;
}
#splash .verte__guide { height: initial; width: initial; max-height: 200px; cursor: pointer; margin-bottom: 20px;  z-index: 100;} #splash .verte__menu { top: 0; right: -10%; z-index: 200 !important; }
#splash .verte__menu---active {  z-index: 200 !important; }
#splash .verte-picker {  z-index: 200 !important; }
#splash .verte-picker---square {  z-index: 200 !important; }
</style>


// WEBPACK FOOTER //
// src/components/Database/Badges/AddContent.vue